// RenewModal.jsx
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const RenewModal = ({ isOpen, toggle, onConfirm }) => {
    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Renew Subscription</ModalHeader>
            <ModalBody>
                Your current subscription has expired. Would you like to renew it?
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="primary" onClick={onConfirm}>Confirm</Button>
            </ModalFooter>
        </Modal>
    );
};

export default RenewModal;
